module.exports = __webpack_public_path__ + "img/person-frame-mb.7c34970b.webp";